<div class="form" *appMailAppContext>
  <div class="form-date">{{ folder?.createdAt | dateFormat : 'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      name="folder"
      [style.color]="folder?.color"
    />
    {{ folder?.title }}
  </h2>

  @if (folder) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="folder"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="folder"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Parent Folder</div>
      <div class="form-details-row-input">{{ folder?.parentId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="folder?.description" />
    </div>
  </div>
</div>
